(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const splide = new Splide('.splide', {
    type: 'slide',
    perPage: 3,
    perMove: 1,
    height: 'auto',
    focus: 'start',
    trimSpace: false,
    pagination: false,
    arrows: true,
    padding: '6rem',
    gap: '1rem',
    drag: true,
    snap: true,
    breakpoints: {
      1400: {
        perPage: 3,
        padding: '2rem',
        gap: '0.2rem',
      },
      1200: {
        perPage: 3,
        padding: 0,
        gap: '0.2rem',
      },
      992: {
        perPage: 3,
        padding: '0.5rem',
        gap: '-1rem',
      },
      768: {
        width: '100%',
        perPage: 2,
        perMove: 1,
        padding: 0,
        gap: '-1rem',
      },
      576: {
        width: '100%',
        perPage: 2,
        perMove: 1,
        padding: 0,
        gap: '-1rem',
      },
      425: {
        width: '100%',
        perPage: 1,
        perMove: 1,
        padding: 0,
        gap: '0rem',
      },
    },
  });

  splide.mount();
});

  } catch(e) { console.error(e); }
})();
})();
